<template>
    <div>
        <el-steps style="margin-bottom:85px" class="applystep"  align-center :active="active" finish-status="success">
            <el-step title="基本信息"></el-step>
            <el-step title="本市住房信息"></el-step>
            <el-step title="添加附件"></el-step>
            <el-step title="完成"></el-step>
        </el-steps>
        <div style="text-align:center">
            <div class="apply-success">
                <img src="../../assets/imgs/pic.png" alt="">
                <div style="margin: 0 auto 0 32px;text-align:left">
                    <p v-if="isExtend">您的续租申请已提交成功，工作人员将在10个工作日内审核并短信通知您提交资料是否通过，如10个工作日内未收到短信提醒请拨打窗口咨询电话:69987999转1，续租租金按当年度调整备案价为准，咨询电话: 69987999转5。</p>
                    <p v-if="!isExtend">您的申请已提交成功，工作人员将在5-10个工作日内审核并短信通知您提交资料是否通过，如5-10个工作日内未收到短信提醒请拨打窗口咨询电话：021-39595036/39968553。</p>
                    <p style="margin-top:28px">登录后，可在 <span style="cursor:pointer;" v-on:click="openApplyList">个人中心-->我的订单--我的申请</span> 中查看详细信息</p>
                </div>
            </div>    
        </div> 
    </div>   
</template>

<script>
export default {
    data(){
        return{
            active:3,
            isExtend:false
        }
    },
    methods:{
        openApplyList(){
            this.$router.push('/User');
        }
    },
    activated(){
        if(this.$route.query.isExtend=="1")
        {
            this.isExtend=true;
        }
    }
}
</script>

<style scoped>
.apply-success{
    display: flex;
    margin: 142px auto 190px;
    align-items: center;
}
.apply-success img{
    margin-left: auto;
    width: 190px;
    height: 132px;
}
.apply-success span{
    color: #2C79CB;
    cursor: pointer;
}
.apply-success p{
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 14px;
}
.applystep >>>.is-process .is-text{
    background: #21A66D;
    border: none;
    color: #fff;
}
.applystep >>>.is-wait .is-text{
    background: #D0D0D0;
    border: none;
    color: #fff;
}
.applystep >>>.is-success .el-step__line{
    background: #21A66D;
}
.applystep >>>.is-success .is-text{
    color: #21A66D;
    border-color:#21A66D;
}
.applystep >>>.el-step__line{
    height: 8px;
    top :6px;
}
.applystep >>>.el-step__title{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
}

</style>